export default __webpack_public_path__ + "static/media/ru.0c02051d.svg";